
import { Config } from '@/config';
import { Prop } from 'vue-property-decorator';

import AppButton from '@/components/Common/AppButton.vue';
import { RefreshIcon } from '@heroicons/vue/solid';
import ProjectList from '@/components/App/ProjectList.vue';
import { GetMonthsDocument, GetSystemRecordDocument, Month, Person, SystemRecord, SystemRecordKey } from '@/graphql/generated-operations';
import { useQuery } from '@vue/apollo-composable';
import { Options, Vue } from 'vue-class-component';
import { format } from 'date-fns';

@Options({
  components: {
    ProjectList,
    AppButton,
    RefreshIcon,
  },
})
export default class Projects extends Vue {

  @Prop({default: null})
  user!: Person;

  months: Month[] = [];
  selectedMonth: Month | null = null;

  @Prop()
  isAdmin = false;

  loading = true;

  syncReportLoaded = false;
  syncReport: SystemRecord | undefined = undefined;

  syncButtonType: 'blue' | 'blue-disabled' = 'blue';
  syncButtonIconClass: '' | 'animate-spin' = '';

  created() {
    const { onResult } = useQuery(GetMonthsDocument, {
      personID: this.user.id
    });

    onResult(queryResult => {
      this.months = queryResult.data.getMonths;

      const currentMonth = format(new Date(), 'y-MM');
      this.months.map((month, index) => {
        if ( month.key == currentMonth ) {
          this.selectedMonth = this.months[index];
        }
      });

      this.loading = false;
    });

    if ( this.isAdmin ) {
      this.fetchSystemRecord();
    }
  }

  fetchSystemRecord() {
    const { onResult } = useQuery(GetSystemRecordDocument, {
      key: SystemRecordKey.SyncProjLastStatus,
    });

    onResult(queryResult => {
      const record = queryResult.data.getSystemRecord;

      if ( record ) {
        this.syncReportLoaded = true;
        this.syncReport = record;
      }
    });
  }

  async syncProjects() {
    this.syncButtonType = 'blue-disabled';
    this.syncButtonIconClass = 'animate-spin';

    const requestUrl = `${Config.getConfig().API_URL}/integrations/projects-sync`;

    fetch(requestUrl, {
      keepalive: true,
    })
      .then(() => {
        this.syncReportLoaded = false;
        this.fetchSystemRecord();

        this.syncButtonType = 'blue';
        this.syncButtonIconClass = '';
      });
  }

  formatDatetime(date: number)
  {
    return format(new Date(Number(date)), 'd. M. Y H:mm:ss');
  }

}
